<table mat-table
        [dataSource]="dataSource()"
        [attr.aria-label]="'research.portal.worksadded.title' | translate"
        class="cdk-visually-hidden visually-hidden"
    >

    <!-- YEAR -->
    <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef> {{ 'research.portal.worksadded.datatable.column.year' | translate }} </th>
        <td mat-cell *matCellDef="let col"> {{ col.name }} </td>
    </ng-container>

    <!-- VALUE -->
    <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef> {{ 'research.portal.worksadded.datatable.column.works' | translate }} </th>
        <td mat-cell *matCellDef="let col"> {{ col.value }} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>